import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import qs from 'querystringify';
import 'react-quill/dist/quill.snow.css';
import {
  Card,
  CONTENT_TYPE,
  Page,
  Text,
  ResourceList,
} from '../components';
import {
  getCarrier,
  getClient,
  getFeatures,
} from '../modules/selectors';
import api from '../utils/services';

const propTypes = {
  features: PropTypes.shape({
    liquidTemplates: PropTypes.bool,
    richText: PropTypes.bool,
    staticHtml: PropTypes.bool,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      carrierId: PropTypes.string,
    }).isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  client: PropTypes.shape({
    clientName: PropTypes.string,
  }).isRequired,
  carrier: PropTypes.shape({
    carrierId: PropTypes.number,
    carrierName: PropTypes.string,
  }).isRequired,
};

class Contents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      contents: null,
    };
  }

  componentDidMount() {
    this.fetchContents();
  }

  componentDidUpdate(previousProps) {
    const { match: { params: { carrierId: previousCarrierId } } } = previousProps;
    const { match: { params: { carrierId } } } = this.props;
    if (previousCarrierId !== carrierId) {
      this.fetchContents();
    }
  }

  fetchContents = () => {
    const { match: { params: { carrierId } } } = this.props;
    this.setState({ loading: true });
    // Since we can't pass query by object,
    // converting the object into query string.
    api.getContentsByCarrier(qs.stringify({ carrierId }, true))
      .then((data) => {
        const filteredData = this.filterByFeature(data);
        this.setState({ contents: filteredData, loading: false });
      });
  }

  filterByFeature = (data) => {
    const { features } = this.props;
    // show data based on the features enabled.Plain text is enabled by default.
    let filteredData = data;
    if (!features.liquidTemplates) {
      filteredData = filteredData.filter(f => f.type !== CONTENT_TYPE.LIQUID);
    }
    if (!features.richText) {
      filteredData = filteredData.filter(f => f.type !== CONTENT_TYPE.QUILL);
    }
    if (!features.staticHtml) {
      filteredData = filteredData.filter(f => f.type !== CONTENT_TYPE.HTML);
    }

    return filteredData;
  }

  render() {
    const {
      match: { params: { carrierId }, url },
      carrier,
      client: { clientName },
    } = this.props;
    const { loading, contents } = this.state;

    let pageTitle;
    let switchContentScope;

    if (carrierId) {
      pageTitle = `${carrier.carrierName} Content`;
      switchContentScope = {
        content: 'View Global Content',
        href: '/contents',
      };
    } else {
      pageTitle = `${clientName} Global Content`;
      switchContentScope = {
        content: `View Carrier (${carrier.carrierName}) Content`,
        href: `/carriers/${carrier.carrierId}/contents`,
      };
    }

    return (
      <Page
        title={pageTitle}
        primaryAction={{ content: 'Create Content', href: `${url}/new` }}
        secondaryActions={[switchContentScope]}
      >
        <Card loading={loading}>
          <ResourceList
            resourceName={{ singular: 'content', plural: 'contents' }}
            items={contents || []}
            renderItem={content => (
              <ResourceList.Item key={content.id} url={`${url}/${content.id}`} id={content.id}>
                <Text as="h3" color={content.name ? undefined : 'lightgrey'}>
                  {content.name || '(Name Missing)'}
                </Text>
                <div>
                  <Text>
                    {`${content.type}`}
                  </Text>
                </div>
              </ResourceList.Item>
            )}
          />
        </Card>
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    features: getFeatures(state),
    carrier: getCarrier(state),
    client: getClient(state),
  };
}
Contents.propTypes = propTypes;
export default connect(mapStateToProps)(Contents);
